export default "__VITE_ASSET__CGjwX6Hn__"